export enum UserRole {
  ADMIN = 'admin',
  CLIENT = 'client',
  USER = 'user'
}
